import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderList, LeaderSortBy} from '../../../apis/leader/getLeader'

const PAGE_SIZE = 10

const useQueryLeaderList = (keyword?: string, exchange?: string, sortBy?: LeaderSortBy, currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getLeaders(exchange, sortBy, currentPage, keyword),
        queryFn: async () => {
            const {data, pageInfo} = await getLeaderList(PAGE_SIZE, currentPage, keyword, exchange, sortBy)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    })

    return {data, refetch}
}

export default useQueryLeaderList
